import React,{ useState, useRef } from 'react';
import { withRouter } from 'react-router';
import {callGET} from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import {getWindowDataUsingId} from '../../../Utils/CommonFunctions';

const TopSearch = props => {
	const [isSearching,setIsSearching] = useState(false);
	const KeyCodes = {
	    comma: 188,
	    enter: 13,
	};
  const delimiters = [KeyCodes.comma, KeyCodes.enter];
  
	const [data,setData] = useState({
		searchTag : false,
		searchText : '',
		tagsList : []
	})
	const tagsRef = useRef(null);
	const toggleSearchTag = (status) => {
		const list = {...data}
		list['searchTag'] = status;
		setData(list);
	}

	const searchTagHandler = () => {
		tagsRef.current.focus();
		setIsSearching(true);
		const API_URL = "tag-mapping/search-tags?searchKeyword="+data.searchText+"&paginator.orderBy=tag_name&paginator.sortAsc=true&paginator.page=0&paginator.size=30";

		// const API_URL = "tag-mapping/search-tags";
	 	callGET(API_URL)
        .then(response => {
			setIsSearching(false);
        	const responseData = response.data;
        	if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
        		const list = {...data}
        		list['searchTag'] = true;
				list['tagsList'] = responseData.data ? responseData.data.content : [];
				setData(list);
				tagsRef.current.focus();
        	}
        })
        .catch(err => {
			setIsSearching(false);
          console.log(err);
        });
	}

	const selectTagsHandler = (val) => {
		const tagsData = JSON.parse(val);
		console.log(val);
		const list = {...data}
		list['searchText'] = tagsData.tag_name;
		list['searchTag'] = false;
		setData(list);
		// toggleSearchTag(false);
		props.globalSearch(val);
		
		if(tagsData.windows) {
			let url = "";//"/tags/"+tagsData.id;
			if(tagsData.windows.length>0) {
				const wind = tagsData.windows[0];
				const data = getWindowDataUsingId(wind.id);
				
				url = "/layouts/"+wind.display_name+"/"+wind.id+"/list/"+data.layout_id+'/tags/'+tagsData.id;
			}
			console.log(url);
			if(url !== '') {
				props.history.push(url);	
			}else {
				props.failMessage("Tag: <span class='text-danger'>"+tagsData.tag_name+"</span> not found in any window");
			}
		}else {
			props.failMessage("Tag: <span class='text-danger'>"+tagsData.tag_name+"</span> not found in any window");
		}
		
		
	}


	const changeHandler = (e) => {
		const {name,value} = e.target;
		const list = {...data}
		list[name] = value;
		console.log(list);
		setData(list);
	}

	const handleKeyDown = (event) => {   
      // console.log("test");     
      if (delimiters.indexOf(event.keyCode) !== -1 ) {
          searchTagHandler();
      }
  }
  let searchHeaderClassName = 'collapse';
  let searchHeaderCss = {position: "relative"};
  if(props.isMobileView===true){
	searchHeaderClassName = 'collapse topSearch_MobileView';
	searchHeaderCss = {display:(props.isSearchVisible===true)?'':'none'}
	// console.log('props.isSearchVisible',props.isSearchVisible);
  }
	
	return (
		<div className={searchHeaderClassName} tabIndex='1' id="search-nav" style={{...searchHeaderCss}}>
						<div className="input-group">
							  {(props.isMobileView===true)?
							  	<div className="input-group-prepend">
								  <a className="btn border-default btn-border" onClick={()=>props.setSearchVisible(false)} id="closeSearch"> <i className="fas fa-times fa-lg"></i> </a>
							  	</div>
							  :''}
				  
              	<input 
              		type="text" 
              		name="searchText"
              		className="form-control form-control-sm topSearch" 
              		placeholder="Search by Tags" 
              		autoComplete="off" 
              		onKeyDown={handleKeyDown}
              		value={data.searchText}
              		onChange={changeHandler}
              		/*onFocus={e=>toggleSearchTag(true)}*/
              	/>
				{(isSearching===true) &&
                  <i
                    className="fas fa-spinner fa-spin fa-lg"
                    style={{
                      position: "absolute",
                      top: "35%",
                      right: "80px", // Adjust based on your padding
                      transform: "translateY(-50%)",
                      color: "#000", // Customize loader color
                      zIndex: '999'
                    }}></i>
                }
              
              	<div className="input-group-append">
                	<a className="btn primary_bg " onClick={searchTagHandler} style={{padding:'7px 13px'}}>
                		Search
                	</a>
              	</div>

            </div>

          <div tabIndex="0" onBlur={e=>toggleSearchTag(false)} ref={tagsRef} className={data.searchTag === true ? "overallSearch_bg" : "overallSearch_bg hide" } >
						<div className="search_Header">
							<h6 className="mb-0"> List of Tags </h6>
							<div className="close" onClick={e=>toggleSearchTag(false)}> <i className="fas fa-times"></i> </div>
						</div>
						
						<div className="search_Body">
						{
							data.tagsList ?
								data.tagsList.length > 0 ?
									data.tagsList.map((arr,ind) => {
										const tagData = JSON.stringify(arr);
										return (
											<div key={ind} className="tagContent" onClick={e=>selectTagsHandler(tagData)}>
												<div className="tagInner">
													<div className="tagInnerWid">
														<label className="taglabel"> 
															<div className="tagText"> {arr.tag_name}  </div>
														</label>
													</div>
												</div>
											</div>
										)
									})
								: <p>No records found</p>
							: null
						}
							
						</div>  
					</div>
			<div className={data.searchTag === true ? "backdrop" : "backdrop hide" }></div>
			<div className="input-group hide">
				<div className="input-group-prepend">
					<button className="btn btn-search pr-1"><i className="fa fa-search primary_color"></i>&nbsp;<i className="fas fa-caret-down primary_color"></i>
					</button>
				</div>
				<input type="text" placeholder="Search by All" className="form-control third_light_color" />
			</div>
		</div>
	);
}

export default withRouter(TopSearch);